import type { SortBy } from 'lib-shared-legacy-types';
import type { SearchSort, SearchSortField } from 'lib-shared-types-api';

import { getSortObjectFromString } from 'utils/url/getSortObjectFromString';

const sortFields: readonly SearchSortField[] = [
  'created_at',
  'last_message_created_at',
  'updated_at',
];

/** Converts a sort object to a URL-friendly string. */
export function convertSortObjectToString(
  sort?: SearchSort,
): SortBy<SearchSortField> | '' {
  return sort ? `${sort.field}:${sort.order}` : '';
}

/** Converts a URL-friendly string to a sort object. */
export function convertSortStringToObject(
  sort?: string,
): SearchSort | undefined {
  if (!sort) return undefined;

  const sortObject = getSortObjectFromString(sort, sortFields);

  if (sortObject && sortObject.direction) {
    return { field: sortObject.key, order: sortObject.direction };
  }
}
